<!--
 * @Description: 
 * @Date: 2020-09-27 09:43:18
 * @LastEditors: jml
-->
<template>
  <div class="success" @click="back">
    <img src="../../img/puzzle/m-tilte.png" class="m-title" alt />
    <div class="box" @click.stop>
      <div class="title">您的成绩为：{{isEdit?'999.99':nowGameTime}}秒</div>
      <div class="best">
        <div class="item">
          <div>最佳成绩</div>
          <div>{{dealTime(theBestTime)}}秒</div>
        </div>
        <div class="item">
          <div>最佳排名</div>
          <div>NO.{{theBestRank}}</div>
        </div>
      </div>
      <div v-if="info.isOpenShareSum" class="share-info">每日分享后，新用户完成注册将再获得{{info.shareSum}}次游戏机会</div>
      <div class="game-count">今天还有{{gameCount}}次游戏机会</div>
      <div class="share-box" :class="{disabled:isEdit}" v-if="info.isOpenShareSum">
        <lShare></lShare>
      </div>
      <img src="../../img/puzzle/btn.png" v-if="gameCount>0" class="btn" @click="palyAgain" alt />
      <img src="../../img/puzzle/btn-back.png" v-else class="btn" @click="back" alt />
    </div>
    <div class="point-group">
      <div class="point"></div>
      <div class="point"></div>
      <div class="point"></div>
    </div>
    <img src="../../img/puzzle/rule-4.png" class="rule" @click.stop="toRulePage" alt />
  </div>
</template>

<script>
import { puzzle } from '@/api/game';
import lShare from './share';
import { dealTime } from '../../config/util';
import { mapMutations, mapActions, mapState } from 'vuex';
import { game } from '../../mixins/game';
export default {
  name: 'puzzleGameSuccess',
  mixins: [game],
  components: { lShare },
  data() {
    return {
      dealTime,
      theBestRank: 0,
      theBestTime: 0,
      gameCount: 0
    };
  },
  props: {
    nowGameTime: {
      default: '000.00',
      type: String
    }
  },
  computed: {
    ...mapState({
      info: state => state.game.info,
      rewards: state => state.game.rewards
    })
  },
  methods: {
    async getGameCount() {
      const { id, channelNo } = this.$route.params;
      const {
        data: { data }
      } = await puzzle.challengeData({
        channelNo,
        activityId: id
      });
      const { paiming, bestAchievement, todayCount, hasEntity } = data;
      this.theBestRank = paiming;
      this.theBestTime = bestAchievement / 10;
      this.gameCount = todayCount;
      const rewardInfo = (this.rewards || [])[paiming - 1] || {};
      if (rewardInfo.prizeType == 1) {
        puzzle.addressData({ channelNo }).then(res => {
          const { data } = res.data;
          if (!data) {
            // 没有收货地址并且有实物奖励
            this.$emit('hasEntity');
          }
        });
      }
    },
    palyAgain() {
      if (this.isEdit && !this.isPreview) {
        return;
      }
      this.$emit('palyAgain');
    },
    back() {
      if (this.isEdit) {
        return;
      }
      this.$emit('back');
    },
    toRulePage() {
      if (this.isEdit && !this.isPreview) {
        return;
      }
      this.$router.push({
        name: 'puzzleGameRule',
        query: this.$route.query
      });
    }
  },
  created() {
    if (this.isEdit) {
      this.theBestRank = 1;
      this.theBestTime = 99999;
      this.gameCount = 2;
    } else {
      this.getGameCount();
    }
  },
  watch: {
    'info.daySum': {
      handler(newV) {
        if (this.isEdit) {
          this.gameCount = newV;
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="less" scoped>
.success {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .m-title {
    width: 6.053rem;
    height: 0.96rem;
    margin-bottom: 0.16rem;
  }
  .box {
    width: 7.707rem;
    // height: 6.267rem;
    background-color: #eb1b31;
    border-radius: 0.373rem;
    padding-top: 0.33rem;
    padding-bottom: 0.067rem;
    text-align: center;
    .title {
      font-size: 0.56rem;
      line-height: 1;
      color: #ffffff;
      margin-bottom: 0.23rem;
    }
    .best {
      width: 7.373rem;
      height: 1.867rem;
      opacity: 0.9;
      background-color: #ffabb4;
      box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.4);
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .item {
        font-size: 0.373rem;
        line-height: 1;
        color: #5b0c15;
        div {
          &:first-child {
            margin-bottom: 0.29rem;
          }
        }
      }
    }
    .share-info {
      font-size: 0.32rem;
      line-height: 1;
      color: #ffd7d1;
      margin-top: 0.373rem;
    }
    .game-count {
      font-size: 0.373rem;
      line-height: 1;
      color: #181818;
      margin-top: 0.253rem;
    }
    .share-box {
      border-top: 1px dashed #ffd7d1;
      width: 7.373rem;
      margin: 0 auto;
      text-align: left;
      padding-top: 0.3rem;
      padding-bottom: 0.2rem;
      margin-top: 0.4rem;
      &.disabled {
        pointer-events: none;
      }
    }
    .btn {
      width: 4.48rem;
      height: 1.667rem;
      margin-top: 0.28rem;
    }
  }
  .point-group {
    padding: 0.173rem 0;
    .point {
      width: 3px;
      height: 3px;
      background-color: #ffc1c1;
      border-radius: 3px;
      margin-bottom: 0.1rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .rule {
    width: 1.787rem;
  }
}
</style>